// extracted by mini-css-extract-plugin
export default {"removeButton":"CompetitorsQualities_removeButton__zx4fT"};